module.exports = __webpack_public_path__ + "img/ELanducalgary.deb4fa93.png";